import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ASSESSMENT_TAB, ASSIGNMENT_TAB, PLANNING_TAB } from 'constants/teamsTabs';
import { getTenant } from 'actions/user';
import { clearAssignmentsFromStore } from 'actions/assignments';
import { clearBlockTypes } from 'actions/blocks';
import { clearCoursesFromStore } from 'actions/courses';
import { clearDocumentsFromStore } from 'actions/documents';
import { clearNotificationsFromStore } from 'actions/notifications';
import { clearPlansFromStore } from 'actions/plans';
import { getMenuItems } from 'actions/menu';
import { clearPostsFromStore } from 'actions/posts';
import { clearNotReportedSchedulePositions, clearScheduleFromStore } from 'actions/schedule';
import { getSchoolServices } from 'actions/schools';
import { clearSectionsFromStore, getEducationGroups } from 'actions/sections';
import { clearSearch } from 'actions/search';
import { ClearAllFilter } from 'actions/ScheduleFilter';
import { Spinner } from 'UI';

var SchoolSwitch = /*#__PURE__*/function (_Component) {
  _inherits(SchoolSwitch, _Component);

  var _super = _createSuper(SchoolSwitch);

  function SchoolSwitch(props) {
    _classCallCheck(this, SchoolSwitch);

    return _super.call(this, props);
  }

  _createClass(SchoolSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      reloadSchoolProps(this.props);
      this.props.getSchoolServices(this.props.activeSchool).then(function () {
        if (_this.props.activeTab != null) {
          if (_this.props.activeTab == ASSIGNMENT_TAB) {
            _this.props.history.push('/assignments-tab');
          } else if (_this.props.activeTab == PLANNING_TAB) {
            _this.props.history.push('/planning-tab');
          } else if (_this.props.activeTab == ASSESSMENT_TAB) {
            _this.props.history.push('/assessments-tab');
          }
        } else {
          _this.props.history.push('/');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "app-comp-content content"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return SchoolSwitch;
}(Component);

export function reloadSchoolProps(props) {
  props.clearSearch();
  props.clearBlockTypes();
  props.clearAssignmentsFromStore();
  props.clearPlansFromStore();
  props.clearSectionsFromStore();
  props.clearDocumentsFromStore();
  props.clearPostsFromStore();
  props.clearScheduleFromStore();
  props.clearCoursesFromStore();
  props.clearNotificationsFromStore();
  props.clearNotReportedSchedulePositions();
  props.getEducationGroups();
  props.getMenuItems();
  props.getTenant();
  props.ClearAllFilter();
}

function mapStateToProps(state) {
  return {
    activeTab: state.user.activeTab,
    activeSchool: state.user.activeSchool
  };
}

export var reloadSchoolActions = {
  clearAssignmentsFromStore: clearAssignmentsFromStore,
  clearBlockTypes: clearBlockTypes,
  clearPlansFromStore: clearPlansFromStore,
  clearSectionsFromStore: clearSectionsFromStore,
  clearDocumentsFromStore: clearDocumentsFromStore,
  clearPostsFromStore: clearPostsFromStore,
  clearScheduleFromStore: clearScheduleFromStore,
  clearCoursesFromStore: clearCoursesFromStore,
  clearNotificationsFromStore: clearNotificationsFromStore,
  clearNotReportedSchedulePositions: clearNotReportedSchedulePositions,
  getEducationGroups: getEducationGroups,
  getMenuItems: getMenuItems,
  clearSearch: clearSearch,
  getTenant: getTenant,
  getSchoolServices: getSchoolServices,
  ClearAllFilter: ClearAllFilter
};
export default withRouter(connect(mapStateToProps, reloadSchoolActions)(SchoolSwitch));